import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { severitiesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = severity => {
    const { onClose, addSeverity, editSeverity, changeMessage } = this.props
    if (severity._id) {
      editSeverity(severity).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addSeverity(severity).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, severity) => {
    e.preventDefault()
    const { setSeverityFormTouched } = this.props

    if ((this.props.severityFormErrors || {}).valid) {
      this.handleSave(severity)
    } else {
      setSeverityFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      severity,
      handleChangeSeverity,
      loadingSeverity,
      severityFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('gravidades', token)

    return (
      <div>
        <Dialog
          modalId={severity._id ? 'gravidades-editar' : 'gravidades-nova'}
          modalParams={{ registro: severity._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingSeverity ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(severity._id ? 'gravidades-editar' : 'gravidades-nova') + '-title'}>
                {isReadOnly ? (
                  'Gravidades'
                ) : (
                  <Fragment>{severity._id ? 'Editar gravidade' : 'Cadastrar gravidade'}</Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'severity-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, severity)
                  }}
                >
                  <FormControl
                    error={!((severityFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Gravidade</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeSeverity({ ...severity, nome: e.target.value })
                      }}
                      value={severity.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((severityFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((severityFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={!((severityFormErrors.fields || {})['cor'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <div style={{ flex: 1 }}>
                      <InputLabel htmlFor="field-cor">Cor</InputLabel>
                      <Input
                        style={{ width: 20 }}
                        disabled={isReadOnly}
                        disableUnderline={true}
                        required={'required'}
                        type="color"
                        onChange={e => {
                          clearErrors()
                          handleChangeSeverity({ ...severity, cor: e.target.value })
                        }}
                        value={severity.cor}
                        id="field-cortabela"
                      />
                    </div>
                    {!((severityFormErrors.fields || {})['cor'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((severityFormErrors.fields || {})['cor'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'severity-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    severity: state.severities.severity,
    loadingSeverity: state.severities.loadingSeverity,
    severityFormErrors: state.severities.severityFormErrors,
    formTouched: state.severities.severityFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(severitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(severitiesActions.closeModal())
    },
    handleChangeSeverity: severity => {
      dispatch(severitiesActions.handleChangeSeverity(severity))
    },
    addSeverity: severity => {
      return dispatch(severitiesActions.addSeverity(severity))
    },
    editSeverity: severity => {
      return dispatch(severitiesActions.editSeverity(severity))
    },
    setSeverityFormTouched: severity => {
      dispatch(severitiesActions.setSeverityFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Severities/EditModal.js